import { Dtos, SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../utils/request";
import { accountQueryKey } from "./account.keys";

export const useFetchSuretyAccount = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const { data, error, isLoading, refetch } = useQuery({
		queryKey: accountQueryKey(accountId),
		queryFn: async () =>
			await get<Dtos.SuretyAccount.Get.Response>(`/v2/surety/accounts/${accountId}`),
		retry: false,
	});

	return {
		suretyAccount: data,
		suretyAccountError: error,
		suretyAccountIsLoading: isLoading,
		refetchSuretyAccount: refetch,
	};
};
